/**
 * 和JIT的驱动通信的本地IP
 * @type {string}
 * @private
 */
let _IP = '127.0.0.1';

if (localStorage.getItem('usb_key_ip')) {
    _IP = localStorage.getItem('usb_key_ip');
}

let CONSTANTS = {
    /**
     * 和JIT的驱动通信的HTTPS URL
     */
    HTTPS_URL: 'https://' + _IP + ':46681',

    /**
     * HTTPS请求成功时的错误码
     */
    HTTPS_SUCCESS_CODE: 200,

    /**
     * 请求参数非法
     */
    PARAMS_INVALID: 100,

    /**
     * 请求正在处理中
     */
    REQUEST_PROCESSING: 500,

    /**
     * HTTPS连接超时时的错误码
     */
    CONNECT_TIMEOUT: 3489660928,

    /**
     * HTTPS连接失败时的错误码
     */
    CONNECT_REFUSED: 3489660929,

    /**
     * HTTPS请求失败时的的错误码
     */
    REQ_FAILED: 3489660930,

    /**
     * HTTPS返回值非法的错误码
     */
    RES_INVALID: 3489660931,

    /**
     * 和JIT的驱动通信的Socket URL
     */
    SOCKET_URL: 'wss://' + _IP + ':46682',

    /**
     * Socket消息成功时的错误码
     */
    SOCKET_SUCCESS_CODE: 0,

    /**
     * Socket错误码：Socket已连接
     */
    SOCKET_CONNECTED: 4026532097,

    /**
     * Socket错误码：Socket打开失败
     */
    SOCKET_OPEN_FAILED: 4026532098,

    /**
     * Socket错误码：Socket服务端发生错误
     */
    SOCKET_SERVER_ERROR: 4026532099,

    /**
     * Socket消息字段：id
     */
    SOCKET_MSG_ID: 'id',

    /**
     * Socket消息字段：return
     */
    SOCKET_MSG_RETURN: 'return',

    /**
     * Socket事件：订阅USBKey插拔事件
     */
    SOCKET_SUB_KEY_EVENT: 'wsSubKeyEvent',

    /**
     * Socket事件：USBKey插拔事件
     */
    SOCKET_KEY_EVENT: 'KeyChanged',

    /**
     * Socket消息字段：keyList
     */
    SOCKET_KEY_LIST: 'keyList',
};
export { CONSTANTS };



// WEBPACK FOOTER //
// ./public/base/utils/constants.js